'use strict';

require('./input-checkbox.scss');

$$('.ll-input-checkbox').each(function () {
	var $checkbox = $$(this),
	    $input = $checkbox.find('.ll-input-checkbox__input');

	$input.on('change', function (event) {
		$checkbox.toggleClass('is-active');
		$checkbox.trigger('change', event);

		event.stopPropagation();
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/components/input/input-checkbox.js
// module id = 86
// module chunks = 0